module.exports = __webpack_public_path__ + "assets/img/bg-btn-hover.28cc03f7.png";